import { history } from 'instantsearch.js/es/lib/routers'

export default function (indexName) {
  return {
    router: history({
      windowTitle({ query }) {
        const queryTitle = query ? `"${query}"` : 'Search'
        return queryTitle + ' - Manaaki Whenua Landcare Research'
      },

      createURL({ qsModule, routeState, location }) {
        const urlParts = location.href.match(/^(.*?)\/search/)
        const baseUrl = `${urlParts ? urlParts[1] : ''}/`

        const queryParameters = {}

        if (routeState.query) {
          queryParameters.query = encodeURIComponent(routeState.query)
        }
        if (routeState.page !== 1) {
          queryParameters.page = routeState.page
        }
        if (routeState.tag) {
          queryParameters.tag = routeState.tag
        }
        if (routeState.type) {
          queryParameters.type = routeState.type
        }

        const queryString = qsModule.stringify(queryParameters, {
          addQueryPrefix: true,
          arrayFormat: 'repeat'
        })

        return `${baseUrl}search/${queryString}`
      },

      parseURL({ qsModule, location }) {
        const pathnameMatches = location.pathname.match(/search\/(.*?)\/?$/)
        const { query = '', page, tag, type } = qsModule.parse(
          location.search.slice(1)
        )
        return {
          query: decodeURIComponent(query),
          page,
          tag: typeof tag === 'string' && tag ? [tag] : tag,
          type: typeof type === 'string' && type ? [type] : type,
        }
      }
    }),

      stateMapping: {
      stateToRoute(uiState) {
        const indexUiState = uiState[indexName] || {}
        let tag = null
        if (indexUiState.refinementList && indexUiState.refinementList.objectTags) {
          tag = indexUiState.refinementList.objectTags
        }
        let type = null
        if (indexUiState.refinementList && indexUiState.refinementList.objectContentType) {
          type = indexUiState.refinementList.objectContentType
        }
        return {
          query: indexUiState.query,
          page: indexUiState.page,
          tag: tag,
          type: type,
        }
      },

      routeToState(routeState) {
        const state = {
          query: routeState.query,
          page: routeState.page,
        }
        state.refinementList = {}
        if (routeState.tag) {
          state.refinementList.objectTags = routeState.tag
        }
        if (routeState.type) {
          state.refinementList.objectContentType = routeState.type
        }
        return {
          [indexName]: state
        }
      }
    }
  }
}
